export enum CheckinStatus {
  DONT_KNOW = 'DONT_KNOW',
  FEELS_GOOD = 'FEELS_GOOD',
  AT_RISK = 'AT_RISK',
  NOT_ACHIEVABLE = 'NOT_ACHIEVABLE'
}
